var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -22.1035,
    y: -25.1931,
    width: 87.2656,
    height: 87.2639
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(14.85px)",
      clipPath: "url(#bgblur_0_416_3637_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_416_3637)",
    "data-figma-bg-blur-radius": 29.709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.453 14.154C35.4546 15.757 35.0564 17.335 34.2945 18.7453C33.5325 20.1556 32.4309 21.3535 31.0892 22.2308C29.7476 23.108 28.2084 23.6367 26.611 23.7692C25.0135 23.9016 23.4082 23.6336 21.9405 22.9893L14.9713 31.0508C14.9553 31.0695 14.9365 31.0896 14.9191 31.107C14.1157 31.9104 13.026 32.3618 11.8897 32.3618C10.7535 32.3618 9.66374 31.9104 8.86029 31.107C8.05684 30.3035 7.60547 29.2138 7.60547 28.0776C7.60547 26.9413 8.05684 25.8516 8.86029 25.0482C8.87903 25.0308 8.89778 25.012 8.91786 24.9959L16.9793 18.0282C16.2571 16.376 16.0123 14.5545 16.2727 12.7702C16.5331 10.986 17.2884 9.31042 18.4528 7.93362C19.6172 6.55683 21.1441 5.53389 22.8603 4.98085C24.5766 4.42782 26.4134 4.36681 28.1626 4.80476C28.3429 4.84995 28.5084 4.9413 28.6427 5.06982C28.777 5.19834 28.8755 5.35961 28.9286 5.53776C28.9817 5.71591 28.9875 5.90481 28.9454 6.08588C28.9033 6.26695 28.8149 6.43395 28.6887 6.57046L23.6727 12.0122L24.4304 15.5396L27.9564 16.2959L33.3981 11.2732C33.5347 11.147 33.7017 11.0586 33.8827 11.0165C34.0638 10.9745 34.2527 10.9803 34.4309 11.0333C34.609 11.0864 34.7703 11.1849 34.8988 11.3193C35.0273 11.4536 35.1187 11.619 35.1639 11.7993C35.356 12.5695 35.4531 13.3603 35.453 14.154Z",
    fill: "url(#paint0_linear_416_3637)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.915 5.15063C24.5995 4.60783 26.4023 4.54797 28.1191 4.97778C28.2694 5.01545 28.4076 5.09136 28.5195 5.19849C28.6315 5.30562 28.7136 5.44061 28.7578 5.58911C28.8019 5.73739 28.8064 5.89447 28.7715 6.04517C28.7364 6.1961 28.6628 6.33567 28.5576 6.44946L23.542 11.8909L23.4795 11.9592L23.498 12.05L24.2559 15.5774L24.2803 15.6897L24.3926 15.7141L27.9189 16.47L28.0098 16.4895L28.0771 16.427L33.5195 11.4045C33.6333 11.2994 33.772 11.2248 33.9229 11.1897C34.0738 11.1546 34.2314 11.1601 34.3799 11.2043C34.5283 11.2486 34.6624 11.3308 34.7695 11.4426C34.85 11.5267 34.9137 11.6251 34.9561 11.7327L34.9912 11.843C35.1797 12.5987 35.2745 13.3747 35.2744 14.1536V14.1545C35.2759 15.7277 34.8855 17.2763 34.1377 18.6604C33.3898 20.0446 32.308 21.2203 30.9912 22.0813C29.6746 22.9421 28.1643 23.461 26.5967 23.5911C25.0288 23.7211 23.4523 23.4588 22.0117 22.8264L21.8916 22.7727L21.8057 22.8723L14.8369 30.9338L14.8359 30.9348C14.8232 30.9497 14.8075 30.9662 14.793 30.9807C14.0229 31.7507 12.9786 32.1838 11.8896 32.1838C10.8007 32.1838 9.75634 31.7507 8.98633 30.9807C8.21638 30.2107 7.78418 29.1663 7.78418 28.0774C7.78423 26.9908 8.21448 25.9485 8.98145 25.179L9.0293 25.135L9.03418 25.1311L17.0957 18.1633L17.1953 18.0774L17.1426 17.9563C16.4338 16.3348 16.1937 14.5472 16.4492 12.7961C16.7048 11.045 17.4461 9.40039 18.5889 8.04907C19.7317 6.69771 21.2305 5.69345 22.915 5.15063Z",
    stroke: "white",
    strokeOpacity: 0.24,
    strokeWidth: 0.356508
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_416_3637",
    x: -22.1035,
    y: -25.1931,
    width: 87.2656,
    height: 87.2639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.08973
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.80275
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.322355 0 0 0 0 0.809176 0 0 0 0.34 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_3637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_3637",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_416_3637"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_416_3637_clip_path",
    transform: "translate(22.1035 25.1931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.453 14.154C35.4546 15.757 35.0564 17.335 34.2945 18.7453C33.5325 20.1556 32.4309 21.3535 31.0892 22.2308C29.7476 23.108 28.2084 23.6367 26.611 23.7692C25.0135 23.9016 23.4082 23.6336 21.9405 22.9893L14.9713 31.0508C14.9553 31.0695 14.9365 31.0896 14.9191 31.107C14.1157 31.9104 13.026 32.3618 11.8897 32.3618C10.7535 32.3618 9.66374 31.9104 8.86029 31.107C8.05684 30.3035 7.60547 29.2138 7.60547 28.0776C7.60547 26.9413 8.05684 25.8516 8.86029 25.0482C8.87903 25.0308 8.89778 25.012 8.91786 24.9959L16.9793 18.0282C16.2571 16.376 16.0123 14.5545 16.2727 12.7702C16.5331 10.986 17.2884 9.31042 18.4528 7.93362C19.6172 6.55683 21.1441 5.53389 22.8603 4.98085C24.5766 4.42782 26.4134 4.36681 28.1626 4.80476C28.3429 4.84995 28.5084 4.9413 28.6427 5.06982C28.777 5.19834 28.8755 5.35961 28.9286 5.53776C28.9817 5.71591 28.9875 5.90481 28.9454 6.08588C28.9033 6.26695 28.8149 6.43395 28.6887 6.57046L23.6727 12.0122L24.4304 15.5396L27.9564 16.2959L33.3981 11.2732C33.5347 11.147 33.7017 11.0586 33.8827 11.0165C34.0638 10.9745 34.2527 10.9803 34.4309 11.0333C34.609 11.0864 34.7703 11.1849 34.8988 11.3193C35.0273 11.4536 35.1187 11.619 35.1639 11.7993C35.356 12.5695 35.4531 13.3603 35.453 14.154Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_416_3637",
    x1: 24.7467,
    y1: 6.80273,
    x2: 27.7467,
    y2: 38.8027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#093EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0762FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.d8a46aca44567a227172a9ba8d2f88f1.svg";
export { ForwardRef as ReactComponent };